export const LOGIN_URL = '/Account/Authenticate';
export const ENABLE_URL = '/Account/Enable2FA/enable-2fa';
export const Verify_URL = '/Account/Verify2FA/verify-2fa';
export const VerifyCONCURRENT_URL = '/Account/Verify2FAwithConcurrent/verify-2fa-Concurrent';
export const TWOFACTORSTATUS_URL = '/Account/UpdateTwoFactorStatus/update-2fa-status';
export const DEACTIVATE_URL = '/Account/DeActivateTwoFactorStatus/DeActivate-2fa-status';
export const REFRESH_URL     = '/Account/RefreshToken/refresh-token';
export const RESETPASSWORDLINK_URL  = '/Account/SendResetPasswordLink/send-reset-password-link';
export const RESETPASSWORD_URL  = '/Account/ResetPassword/reset-password';
export const VALIDATERESETOKEN_URL  = '/Account/ValidateResetToken/validate-reset-token';
export const TERMINATE_URL  = '/Account/TerminateOtherSessions/terminate-session';
export const AUTHORIZEDDEALER_URL  = '/AuthorizedDealer/GetAllDealer';
export const TENANTCREATE_URL  = '/Tenant/Create/create';
export const TENANTEDIT_URL  = '/Tenant/Update/update';
export const TENANTALL_URL  = '/Tenant/GetAll';
export const TENANTALLGS_URL  = '/Tenant/GetAllGS';
export const TENANTID_URL  = '/Tenant/GetById';
export const TENANTDELETE_URL  = '/Tenant/Delete/delete';
export const ROLECREATE_URL  = '/Role/Create';
export const ROLEEDIT_URL  = '/Role/Update';
export const ROLEALL_URL  = '/Role/GetAll';
export const ROLEID_URL  = '/Role/GetById';
export const ROLEDELETE_URL  = '/Role/Delete/';
export const USERALL_URL  = '/User/GetAll/getAll';
export const USERDELETE_URL  = '/User/DeleteUser/delete';
export const USERBRANCH_URL  = '/User/GetBranchByTenant';
export const USERCREATE_URL  = '/User/CreateUser/create';
export const USEREDIT_URL  = '/User/UpdateUser/update';
export const USERID_URL  = '/User/GetById/getById';
export const FUNCTIONALALL_URL  = '/FunctionalMaster/GetAll';
export const FUNCTIONALID_URL  = '/FunctionalMaster/GetById';
export const FUNCTIONALDELETE_URL  = '/FunctionalMaster/Delete';
export const FUNCTIONALEDIT_URL  = '/FunctionalMaster/Update';
export const FUNCTIONALCREATE_URL  = '/FunctionalMaster/Create';
export const FEATUREALL_URL  = '/Feature/GetAll';
export const FEATUREID_URL  = '/Feature/GetById';
export const FEATUREDELETE_URL  = '/Feature/Delete';
export const FEATUREEDIT_URL  = '/Feature/Update';
export const FEATURECREATE_URL  = '/Feature/Create';
export const FEATURECREATENEW_URL  = '/FunctionalMaster/CreateFeaturePermissions';
export const FEATUREIDNEW_URL  = '/FunctionalMaster/GetFeaturePermissions';
export const FUNCTIONALALLNEW_URL  = '/FunctionalMaster/GetroleIds';
export const GETROUTER_URL  = '/FunctionalMaster/GetRouterLinksByRoles';
export const GETBRANCH  = '/Account/GetBranchNames/get-branch-names';

//commontype
export const GETALL_COMMONTYPE_URL  = '/CommonTypeMaster/GetAllCommonTypeMasterQuery';
export const CREATE_COMMONTYPE_URL  = '/CommonTypeMaster/CreateCommonTypeMaster';
export const UPDATE_COMMONTYPE_URL  = '/CommonTypeMaster/UpdateCommonTypeMaster';
export const DELETE_COMMONTYPE_URL  = '/CommonTypeMaster/DeleteCommonTypeMaster';

//Currency 
export const GETALLCURRENCY_URL  = '/CurrencyMaster/GetAllCurrencyMaster';
//country 
export const GETALL_COUNTRY_URL  = '/CurrencyMaster/GetAllcountrydtl';

//product master
export const GETALL_PRODUCTMASTER_URL  = '/ProductDetail/GetAllProduct';
export const CREATE_PRODUCTMASTER_URL  = '/ProductDetail/CreateProductDetail';
export const UPDATE_PRODUCTMASTER_URL  = '/ProductDetail/UpdateProduct';
export const DELETE_PRODUCTMASTER_URL  = '/ProductDetail/DeleteProduct';
export const GETDETAIL_PRODUCTMASTER_URL  = '/ProductDetail/GetProductById';
//common master
export const GETALLCOMMONMASTER_URL  = '/CommonMaster/GetAllCommonMaster';
export const CREATE_COMMONMASTER_URL  = '/CommonMaster/CreateCommonMaster';
export const UPDATE_COMMONMASTER_URL  = '/CommonMaster/UpdateCommonMaster';
export const DELETE_COMMONMASTER_URL  = '/CommonMaster/DeleteCommonMaster';

//Nature of Business
export const GETALL_NATUREOFBUSINESS_URL='/NatureOfBusiness/GetAllNatureOfBusiness';
export const DELETE_NATUREOFBUSINESS_URL='/NatureOfBusiness/DeleteNatureOfBusiness';
export const UPDATE_NATUREOFBUSINESS_URL='/NatureOfBusiness/UpdateNatureOfBusiness';
export const CREATE_NATUREOFBUSINESS_URL='/NatureOfBusiness/CreateNatureOfBusiness';

//branch master
export const GETALL_BRANCHMASTER_URL  = '/Branch/GetAllBranch';
export const CREATE_BRANCHMASTER_URL  = '/Branch/CreateBranch';
export const UPDATE_BRANCHMASTER_URL  = '/Branch/UpdateBranch';
export const DELETE_BRANCHMASTER_URL  = '/Branch/DeleteBranch';
export const GETDETAIL_BRANCHMASTER_URL  = '/Branch/GetBranchById';
export const GETBYTENENT_BRANCHMASTER_URL  = '/Branch/GetAllBrachByTenantId';

//employee master
export const GETALL_EMPLOYEEMASTER_URL  = '/EmployeeMaster/GetAllEmployee';
export const CREATE_EMPLOYEEMASTER_URL  = '/EmployeeMaster/CreateEmployee';
export const UPDATE_EMPLOYEEMASTER_URL  = '/EmployeeMaster/UpdateEmployee';
export const DELETE_EMPLOYEEMASTER_URL  = '/EmployeeMaster/DeleteEmployee';

//individual master
export const GETALL_CUSTOMER_URL  = '/IndividualProfile/GetAllIndividualProfile';
export const CREATE_CUSTOMER_URL  = '/IndividualProfile/CreateIndividualProfile';
export const UPDATE_CUSTOMER_URL  = '/IndividualProfile/UpdateIndividualProfile';
export const DELETE_CUSTOMER_URL  = '/IndividualProfile/DeleteIndividualProfile';
export const GETBYID_CUSTOMER_URL  = '/IndividualProfile/GetIndividualPeofileById';
export const GETBY_IDTYPE_URL = '/IndividualProfile/GetByIdTypeId';

//individual id 
export const CREATE_INDIVIDUALID_URL  = '/IndividualProfileId/createIndividualprofileId';
export const DELETE_INDIVIDUALID_URL  = '/IndividualProfileId/DeleteIndividualProfileId';
export const GETALL_INDIVIDUALID_URL  = '/IndividualProfileId/GetAllIndividualProfileId';
export const UPDATE_INDIVIDUALID_URL  = '/IndividualProfileId/UpdateIndividualProfileId';
export const DOWNLOAD_INDIVIDUALID_URL  = '/IndividualProfileId/Vendor/Download';

//corporate profile master
export const GETALL_CORPORATE_URL  = '/CorporateProfile/GetAllCorporate';
export const CREATE_CORPORATE_URL  = '/CorporateProfile/CreateCorporateProfile';
export const UPDATE_CORPORATE_URL  = '/CorporateProfile/UpdateCorporateProfile';
export const DELETE_CORPORATE_URL  = '/CorporateProfile/DeleteCorporateProfile';
export const GETBYID_CORPORATE_URL  = '/CorporateProfile/GetCorporatebyId';

//upload corporate master
export const CREATE_CORPORATE_UPLOAD_URL  = '/CorporateProfile/CreateCorporateUpload';
export const DELETE_CORPORATE_UPLOAD_URL  = '/CorporateProfile/DeleteCorporateUpload';
export const UPDATE_CORPORATE_UPLOAD_URL  = '/CorporateProfile/UpdateCorporateUpload';
export const GET_CORPORATE_UPLOAD_URL  = 'CorporateProfile/Corporate/Download';

//vendor
export const GETALL_VENDOR_URL  = '/Vendor/GetAllVendor';
export const CREATE_VENDOR_URL  = '/Vendor/CreateVendorMaster';
export const UPDATE_VENDOR_URL  = '/Vendor/UpdateVendorMaster';
export const DELETE_VENDOR_URL  = '/Vendor/DeleteVendor';
export const GETBYID_VENDOR_URL  = '/Vendor/GetVendorMasterById';

//upload vendor
export const CREATE_VENDOR_UPLOAD_URL  = '/Vendor/UploadVendor';
export const DELETE_VENDOR_UPLOAD_URL  = '/Vendor/DeleteVendorUpload';
export const UPDATE_VENDOR_UPLOAD_URL  = '/Vendor/UpdateVendorUpload';
export const GET_VENDOR_UPLOAD_URL  = '/Vendor/Vendor/Download';

//rate 
export const CREATE_RATEMARGIN_URL  = '/RateMaster/CreateRateMaster';
export const DELETE_RATEMARGIN_URL  = '/RateMaster/DeleteRateMaster';
export const GETALL_RATEMARGIN_URL  = '/RateMaster/GetAllRateMAster';
export const UPDATE_RATEMARGIN_URL  = '/RateMaster/UpdateRateMaster';
export const GETRATE_RATEMARGIN_URL  = '/CurrencyBoard/GetCurrencyByCurrencyId';
export const GET_RATE_VTM_URL="/SVTMRate/GetAllSVTMRate"
export const CREATE_RATE_VTM_URL="/SVTMRate/CreateSVTMRate"

//Account group
export const GETALL_ACCOUNTGROUP_URL  = '/AccountGroup/GetAllAccountGroups';
export const CREATE_ACCOUNTGROUP_URL  = '/AccountGroup/CreateAccountGroup';
export const GETBYID_ACCOUNTGROUP_URL  = '/AccountGroup/GetAccountGroupById';
export const DELETE_ACCOUNTGROUP_URL  = '/AccountGroup/DeleteAccountGroup';
export const UPDATE_ACCOUNTGROUP_URL  = '/AccountGroup/UpdateAccountGroup';

//ledger
export const GETALL_LEDGER_URL = `/Ledger/GetAllLedger`;
export const CREATE_LEDGER_URL = `/Ledger/CreateLedger`;
export const GETBYID_LEDGER_URL = `/Ledger/GetLedgerById`;
export const UPDATE_LEDGER_URL = `/Ledger/UpdateLedger`;


export const GETALL_SALEPURCHASE_URL  = '/RateMaster/GetSalePurchase';
export const GETALL_SALEPURCHASEBYDATE_URL  = '/RateMaster/GetRateCardByDate';
export const GETALL_SALEPURCHASELATEST_URL  = '/RateMaster/GetLatestRateCard';

//sale to public
export const GETALL_SALE_TO_PUBLIC_URL  = '/SaleToPublic/GetAllSalesTransactionInfo';
export const CREATE_SALE_TO_PUBLIC_URL  = '/SaleToPublic/CreateSalesTransactionInfo';
export const UPDATE_SALE_TO_PUBLIC_URL  = '/SaleToPublic/UpdateSalesTransactionInfo';
export const DELETE_SALE_TO_PUBLIC_URL  = '/SaleToPublic/DeleteSalesTransactionInfo';
export const GETBYID_SALE_TO_PUBLIC_URL  = '/SaleToPublic/GetSalesTransactionInfoById'; 
export const HISTORY_SALE_TO_PUBLIC_URL  = '/SaleToPublic/GetPurchaseHistory'; 
export const PAYMENT_SALE_TO_PUBLIC_URL  = '/SaleToPublic/GetSalePaymentById'; 

//charge
export const CHARGES_SALE_TO_PUBLIC_URL  = '/SaleToPublic/GetSaleToPubCharges'; 
export const CREATE_CHARGES_SALE_TO_PUBLIC_URL  = '/SaleToPublic/CreateSaleToPublicCharges'; 

export const GETALL_SALE_TO_PUBLIC_PAYMENT_URL  = '/SaleToPublic/GetAllSaleToPubPayment';
export const CREATE_SALE_TO_PUBLIC_PAYMENT_URL  = '/SaleToPublic/CreateSaleToPublicPayment';
// export const UPDATE_SALE_TO_PUBLIC_PAYMENT_URL  = '/SaleToPublic/UpdateSaleToPublicPayment';
// export const DELETE_SALE_TO_PUBLIC_PAYMENT_URL  = '/SaleToPublic/DeleteSaleToPublicPayment';
// export const GETBYID_SALE_TO_PUBLIC_PAYMENT_URL  = '/SaleToPublic/DeleteSaleToPublicPayment'; 

export const GETALL_SALE_TO_PUBLIC_DETAIL_URL  = '/SaleToPublic/GetAllSaleToPublicDetail';
export const CREATE_SALE_TO_PUBLIC_DETAIL_URL  = '/SaleToPublic/CreateSaleToPublicDetails'; 

export const GETALL_SALE_TO_PUBLIC_COMMISSION_URL  = '/SaleToPublic/GetAllSaleToPublicCommission';
export const CREATE_SALE_TO_PUBLIC_COMMISSION_URL  = '/SaleToPublic/CreateSaleToPublicCommission'; 

export const GETALL_SALE_TO_PUBLIC_DOC_URL  = '/SaleToPublic/GetAllSaleToPubDoc';
export const CREATE_SALE_TO_PUBLIC_DOC_URL  = '/SaleToPublic/CreateSaleToPubDoc'; 
export const UPDATE_SALE_TO_PUBLIC_DOC_URL  = '/SaleToPublic/UpdateSaleToPubDoc'; 
export const DOWNLOAD_SALE_TO_PUBLIC_DOC_URL  = '/SaleToPublic/Corporate/Download'; 
export const DELETE_SALE_TO_PUBLIC_DOC_URL  = '/SaleToPublic/DeleteSaleToPubDoc'; 
export const DENO_SALE_TO_PUBLIC_URL  = '/SaleToPublic/GetDenominationById'; 

export const GET_SALE_TO_PUBLIC_INVOICE='SaleToPublic/GetDenominationById'
export const GET_SALE_TO_PUBLIC_INVOICE_SALES='SaleToPublic/GetSaleToPubDenominationById'
export const GET_SALE_TO_PUBLIC_A2FORM='SaleToPublic/GetA2formById'
export const GET_SALE_TO_PUBLIC_LRSFORM='SaleToPublic/GetLrsformById'
export const GET_SALE_TO_PUBLIC_LRS_PREV_TRANS='SaleToPublic/GetSaleLrsHistory'

//state master
export const GETALL_STATE_MASTER  = '/State/GetAllState'; 
export const CREATE_STATE_MASTER  = 'State/CreateStateMaster';
//feedback
export const FEEDBACK  = '/Feedback/SubmitFeedback/submit';
export const FEEDBACKALL  = '/Feedback/GetAllFeedback';
export const FEEDBACKDOWNLOAD  = '/Feedback/DownloadFile/download';

//purchase from public
export const GET_PURCHASE_FROM_PUBLIC_GETALL='/PurchaseFromPublicInformation/GetAllPurchaseFromPublicInformation'
export const CREATE_PURCHASE_FROM_PUBLIC_INFORMATION_URL = '/PurchaseFromPublicInformation/CreatePurchaseFromPublicInformation'
export const CREATE_PURCHASE_FROM_PUBLIC_DETAILS_URL = '/PurchaseFromPublicInformation/CreatePurchasePublicDetail'
export const CREATE_PURCHASE_FROM_PUBLIC_COMMISSION_URL = '/PurchaseFromPublicInformation/CreatePurchasePublicCommissionPaid'
export const CREATE_PURCHASE_FROM_PUBLIC_PAYMENT_URL = '/PurchaseFromPublicInformation/CreatePurchasePublicPayment'
export const CREATE_PURCHASE_FROM_PUBLIC_DOCUMENT_URL = '/PurchaseFromPublicInformation/CreatePurchaseDocument'
export const CREATE_PURCHASE_FROM_PUBLIC_SUSPICIOUSTRANSACTION = '/PurchaseFromPublicInformation/CreateSuspiciousTransaction'
export const GET_PURCHASE_FROM_PUBLIC_PREVIOUS_TRANSACTION = 'PurchaseFromPublicInformation/GetPurchaseHistory'
export const GET_PURCHASE_FROM_PUBLIC_OTHER_CHARGES='PurchaseFromPublicInformation/GetPurchase'
export const GET_PURCHASE_FROM_PUBLIC_ALL_INFO='PurchaseFromPublicInformation/GetPurchasePublicInformationById'
export const GET_PURCHASE_FROM_PUBLIC_CHARGES_BY_ID='PurchaseFromPublicInformation/GetPurchaseChargeById'
export const CREATE_PURCHASE_FROM_PUBLIC_CHARGES='PurchaseFromPublicInformation/CreatePurchaseCharges'
export const GET_PURCHASE_FROM_PUBLIC_DOCUMENT_DOWNLOAD='PurchaseFromPublicInformation/PurchaseDocument/Download'
export const DELETE_PURCHASE_FROM_PUBLIC_DOCUMENT_DELETE='PurchaseFromPublicInformation/DeletePurchaseDocument'
export const UPDATE_PURCHASE_FROM_PUBLIC_DOCUMENT='PurchaseFromPublicInformation/UpdatePurchasePublicDocument'
export const GET_PURCHASE_FROM_PUBLIC_INVOICE='PurchaseFromPublicInformation/GetDenominationById'
export const UPDATE_PURCHASE_FROM_PUBLIC_DOCUMENT_UPDATE='PurchaseFromPublicInformation/UpdatePurchasePublicDocument'
export const CREATE_CDF_PURCHASE_FROM_PUBLIC = 'Cdf/CreateCdfForm'
export const UPDATE_CDF_PURCHASE_FROM_PUBLIC = 'Cdf/UpdateCdfForm'
export const DELETE_CDF_PURCHASE_FROM_PUBLIC = 'Cdf/DeleteCdfForm'
export const DOWNLOAD_CDF_PURCHASE_FROM_PUBLIC = 'Cdf/EncashMentCertificate/Download'

//opening balance
export const GET_OPENING_BALANCE_GETALL='/FinancialYear/GetAllOpeningBalances'
export const CREATE_OPENING_BALANCE='/FinancialYear/CreateOpeningBalances'      
export const UPDATE_OPENING_BALANCE='/FinancialYear/UpdateOpeningBalances'
export const GET_OPENING_BALANCE_BY_ID='/FinancialYear/GetOpeningBalanceById'

// Financial Year
export const GETALL_FINANCIALYEAR_URL  = '/FinancialYear/GetAllFinancialYear';
export const CREATE_FINANCIAL_YEAR_URL = '/FinancialYear/CreateFinancialYear';
export const UPDATE_FINANCIAL_YEAR_URL = '/FinancialYear/UpdateFinancialYear';
export const GETBYID_FINANCIAL_YEAR_URL = '/FinancialYear/GetFinancialYearById';
   
//Voucher Type
export const GETALL_VOUCHERTYPE_URL  = '/Voucher/GetAllVoucherTypes';
export const CREATE_VOUCHERTYPE_URL = '/Voucher/CreateVoucherType';
export const UPDATE_VOUCHERTYPE_URL = '/Voucher/UpdateVoucherType';
export const GETBYID_VOUCHERTYPE_URL = '/Voucher/GetVoucherTypesById';

//currencystock
export const GETALL_CURRENCYSTOCK_URL  = '/CurrencyStock/GetByFinancialYear';
export const GET_CURRENCYSTOCK_PRINT = '/CurrencyStock/GetStockToPrint/GetStockToPrint';

//VTC In
export const GETBYID_VTCIn = '/VtcIn/GetVtcInInfo';
export const GETALL_VTCIn_URL  = '/VtcIn/GetAllVtcInInfo';

// VTC In Info
export const CREATE_VTCInInfo_URL = '/VtcIn/CreateVtcInInfo';

// VTC In Detail
export const CREATE_VTCInDetail_URL = '/VtcIn/CreateVtcInDetail';

// VTC Out
export const GETBYID_VTCOut = '/VtcOut/GetVtcOutById';
export const GETALL_VTCOut_URL = '/VtcOut/GetAllVtcOutInfo';

// VTC Out Info
export const CREATE_VTCOutInfo_URL = '/VtcOut/CreateVtcOutInfo';

// VTC Out Detail
export const CREATE_VTCOutDetail_URL = '/VtcOut/CreateVtcOutDetail';

//bank master 
export const GETALL_BANKMASTER_URL  = '/Bankmaster/GetAllBankmaster';
export const CREATE_BANKMASTER_URL  = '/Bankmaster/CreateBankmaster';
export const UPDATE_BANKMASTER_URL  = '/Bankmaster/UpdateBankmaster';
export const DELETE_BANKMASTER_URL  = '/Bankmaster/DeleteBankmaster';
export const GETBY_BANKMASTER_URL  = '/Bankmaster/GetBankById';

//bank masterdetail 
export const GETALL_BANKDETAILMASTER_URL  = '/Bankmaster/GetAllBankDetails';
export const CREATE_BANKDETAILMASTER_URL  = '/Bankmaster/CreateBankDetails';
export const UPDATE_BANKDETAILMASTER_URL  = '/Bankmaster/UpdateBankdetails';
export const DELETE_BANKDETAILMASTER_URL  = '/Bankmaster/DeleteBankdetails';
export const GETBY_BANKDETAILMASTER_URL  = '/Bankmaster/GetBankDetailsById';

//EVTM Surrender
export const CREATE_SURRENDER_EVTMINFO_URL = '/SurrenderEvtm/CreateSurrenderEvtmInfo';
export const CREATE_SURRENDER_EVTMDETAILS_URL = '/SurrenderEvtm/CreateSurrenderEvtmDetails';
export const CREATE_SURRENDER_EVTMPAYMENTS_URL = '/SurrenderEvtm/CreateSurrenderEvtmPayments';
export const GETBYID_SURRENDER_EVTM_URL = '/SurrenderEvtm/GetSurrenderEVtmById';
export const GETALL_SURRENDER_EVTMINFO_URL = '/SurrenderEvtm/GetAllSurrenderEVtmInfo';

//Currency stock
export const CREATE_CURRENCY_OUT_URL = '/CurrencyOut/CreateCurrencyOutInfoAndDetails';
export const GETINFOBYID_CURRENCY_OUT_URL = '/CurrencyOut/GetCurrencyOutInfoById';
export const UPDATE_CURRENCY_OUT_STATUS_URL = '/CurrencyOut/UpdateStatus';
export const GETALL_CURRENCY_OUT_URL = '/CurrencyOut/GetAllCurrencyOutInfo';
//EVTM Settlement
export const GETALL_SETTLEMENT_VTM = '/VtmSettlementInfo/GetAllVtmSettlementInfo';
export const CREATE_EVTM_SETTLEMENT_INFO = '/VtmSettlementInfo/CreateVtmSettlementInfo';
export const CREATE_EVTM_SETTLEMENT_DETAIL = '/VtmSettlementInfo/CreateVtmSettlementDetail';
export const CREATE_EVTM_SETTLEMENT_PAYMENT = '/VtmSettlementInfo/CreateVtmSettlementPayment';
export const GET_EVTM_SETTLEMENT_BY_ID = '/VtmSettlementInfo/GetVtmSettlementById';

//Get Vtm card details

export const GET_SALES_DETAILS_BY_CARD_NO = '/SaleToPublic/GetSalesDetailsByCardNo';
export const GET_PURCHASE_DETAILS_BY_CARD_NO = '/PurchaseFromPublicInformation/GetByCardNo';

//Purchase Invoice
export const GETALL_PURCHASE_INVOICE_URL='/PurchaseInvoice/GetAllPurchaseInvoice'
export const GETBYID_PURCHASE_INVOICE='/PurchaseInvoice/GetPurchaseInvoiceById'
export const GET_DOWNLOAD_PURCHASE_INVOICE='PurchaseInvoice/PurchaseDocument/Download'
export const CREATE_PURCHASE_INVOICE_INFO='/PurchaseInvoice/CreatePurchaseInvoiceInfo'
export const CREATE_PURCHASE_INVOICE_DETAIL='/PurchaseInvoice/CreatePurchaseInvoiceDetail'
export const CREATE_PURCHASE_INVOICE_PAYMENT='/PurchaseInvoice/CreatePurchaseInvoicePayment'
export const CREATE_PURCHASE_INVOICE_DOCUMENT='/PurchaseInvoice/CreatePurchaseDocument'
export const CREATE_UPDATE_PURCHASE_INVOICE_DOCUMENT='/PurchaseInvoice/UpdatePurchaseInvoiceDocument'
export const DELETE_PURCHASE_INVOICE_DOCUMENT='/PurchaseInvoice/DeletePurchaseInvoiceDocument'
export const GET_PURCHASE_INVOICE_COMMON_CHARGE='/PurchaseInvoice/GetInvoiceCommon'

//voucher entry
export const GETALL_VOUCHER_URL = '/Voucher/GetAllVoucher';
export const GETBYID_VOUCHER_URL = '/Voucher/GetVoucherItemByVoucherId';
export const CREATE_VOUCHER_URL = '/Voucher/CreateVoucherEntry';

//Sale Invoice
export const GETALL_SALE_INVOICE_URL='/SaleInvoice/GetAllSaleInvoiceInformation'
export const GETBYID_SALE_INVOICE='/SaleInvoice/GetSaleInvoiceInformationById'
export const CREATE_SALE_INVOICE_INFO='/SaleInvoice/CreateSaleInvoiceInformation'
export const CREATE_SALE_INVOICE_DETAIL='/SaleInvoice/CreateSaleInvoiceDetail'
export const CREATE_SALE_INVOICE_PAYMENT='/SaleInvoice/CreateSaleInvoicePayment'
export const CREATE_SALE_INVOICE_DOCUMENT='/SaleInvoice/CreateSaleInvoiceDocument'
export const UPDATE_SALE_INVOICE_DOCUMENT='/SaleInvoice/UpdateSaleInvoiceSocument'
export const DELETE_SALE_INVOICE_DOCUMENT='/SaleInvoice/DeleteSaleInvoiceDocument'
export const GET_DOWNLOAD_SALE_INVOICE_UPLOAD='SaleInvoice/PurchaseDocument/Download'
export const GET_SALE_INVOICE_COMMON_CHARGE='/SaleInvoice/GetInvoiceCommon'

//Bill Printing
export const GET_BILL_PRINT='/Tools/GetSaleBulkBill'
export const GET_ALL_BILL_PRINT='/Tools/GetAllSaleBill'

//report
export const REPORTCREATE_URL  = '/Report/Create';
export const REPORTEDIT_URL  = '/Report/Update';
export const REPORTEALL_URL  = '/Report/GetAll';
export const REPORTID_URL  = '/Report/GetById';
export const REPORTDELETE_URL  = '/Report/Delete/';
export const REPORTFEATUREALL_URL  = '/Report/GetAllFeature';
export const REPORTFEATUREID_URL  = '/Report/GetByIdFeature';
export const REPORTFEATUREDELETE_URL  = '/Report/DeleteFeature';
export const REPORTFEATUREEDIT_URL  = '/Report/UpdateFeature';
export const REPORTFEATURECREATE_URL  = '/Report/CreateFeature';
export const REPORTFEATUREIDNEW_URL  = '/Report/GetFeaturePermissions';
export const REPORTCATEGORY_URL  = '/Report/GetCategoryPermissions';
export const REPORTFEATURECREATENEW_URL  = '/Report/CreateFeaturePermissions';
export const REPORTROLEIDNEW_URL  = '/Report/GetReportPermissions';
export const REPORTGENERATION_URL  = '/Report/ExecuteReport/execute';

//Sale Encashment Ceriticate
export const CREATE_SALE_ENCASHMENT= '/SaleToPublic/CreateSaleEncashmentCertificate'
export const UPDATE_SALE_ENCASHMENT = '/SaleToPublic/UpdateSaleEncashmentCertificate'
export const DELETE_SALE_ENCASHMENT= '/SaleToPublic/DeleteSaleEncashmentCertificate'
export const DOWNLOAD_SALE_ENCASHMENT= 'SaleToPublic/EncashMentCertificate/Download'
